import DefaultAdmin from "src/components/feature/Admin";

const Admin = () => {
  return <DefaultAdmin />;
};

export default Admin;
